
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.28 8.22c.14-.14.331-.22.53-.22h.38a.77.77 0 01.53.22l5.13 5.14a.5.5 0 010 .71l-.71.71a.49.49 0 01-.7 0L12 10.33l-4.44 4.45a.5.5 0 01-.71 0l-.7-.71a.5.5 0 010-.71l5.13-5.14z"}})])
          )
        }
      }
    